import api from './client'
import type { Deck } from '@/types/deck'

export function fetchDecks(languageId: number) {
  return api.get<{ data: Deck[] }>('/decks', {
    params: { language_id: languageId },
  })
}

export function createDeck(languageId: number, name: string) {
  return api.post<{ data: Deck }>('/decks', { deck: { language_id: languageId, name } })
}

export function updateDeck(id: number, name: string) {
  return api.patch<{ data: Deck }>(`/decks/${id}`, { deck: { name } })
}

export function deleteDeck(id: number) {
  return api.delete<void>(`/decks/${id}`)
}
